import { precalcLessons1 } from './precalcLessons1';
import { precalcLessons2 } from './precalcLessons2';
import { precalcLessons3 } from './precalcLessons3';

export const allLessons = [
  ...precalcLessons1,
  ...precalcLessons2,
  ...precalcLessons3,
];

export { precalcTests } from './precalcTests';
export type { PrecalcTest, TestQuestion } from './precalcTests';
